import { page } from '$app/state'
import { goto } from '$app/navigation'
import { appState } from '$lib/app-state.svelte'

// Callback for Google One Tap initialized in +layout.svelte.
// Cannot use HTML API because this callback will not be registered when the script is loaded
export async function callback(response: google.accounts.id.CredentialResponse) {
	appState.loginMessage = ''
	if (appState.user) return

	const res = await fetch('/auth/google', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ token: response.credential })
	})

	if (!res.ok) {
		if (res.status == 401) {
			appState.loginMessage = 'Please make sure you are logging in to an existing student account.'
			return
		}
		const { message } = await res.json()
		throw new Error(message)
	}

	const { user }: { user: User } = await res.json()
	appState.user = user

	const referrer = page.url.searchParams.get('referrer')

	if (referrer) return goto(referrer)

	switch (user!.role) {
		case 'teacher':
			goto('/shynet')
			break
		case 'admin':
			goto('/admin')
			break
		default:
			if (location.pathname === '/login') goto('/')
	}
}
